import styles from "./SearchSection.module.css";
import PropTypes, { node } from "prop-types";

import E3Button from "../InputControls/E3Button";
import { createSectionTableLayout } from "../Utils/sectionControlUtil";
import { existChk } from "e3-common/utils/controlsUtil";

/**
 * 조회 영역 Container
 * 자식 노드가 있는 경우, 자식 노드를 렌더링함 (일반적으로 <table> 태그로 시작)
 * 자식 노드가 없는 경우, searchControls의 형태에 따라 렌더링
 * @returns
 */
function SearchSection(props) {
  if (props.children) {
    return <div className={styles.searchSection}>{props.children}</div>;
  }

  const rowsJsx = createSectionTableLayout(
    props.searchControls,
    props.numOfCols,
    props.searchOptions
  );

  const trsJsx = rowsJsx?.map((tds, index) => <tr key={index}>{tds}</tr>);

  return (
    <div className={styles.searchSection}>
      <div className={styles.controlArea}>
        <table>
          <tbody>{trsJsx}</tbody>
        </table>
      </div>

      <div
        className={`${styles.areaBtn} ${
          props.btnAlign === "right"
            ? styles.right
            : props.btnAlign === "center"
            ? styles.center
            : props.btnAlign === "left"
            ? styles.left
            : ""
        } `}
      >
        {props.btnSearch && existChk(props.btnSearch) ? (
          <>
            {props.additionalBtns ? props.additionalBtns : null}
            <E3Button
              {...(props.btnSearch.ref && { ref: props.btnSearch.ref })}
              buttonType={"search"}
              authBtn={props.btnSearch.authBtn ?? "SEARCH"}
              onClick={props.btnSearch.onClick}
              label={props.btnSearch.label ?? "조회"}
              checkAuth={props.btnSearch.checkAuth}
              colorType={props.btnSearch.colorType}
              iconType={props.btnSearch.iconType}
            />
            {props.additionalRightBtns ? props.additionalRightBtns : null}
          </>
        ) : props.additionalRightBtns ? (
          props.additionalRightBtns
        ) : null}
      </div>
    </div>
  );
}

SearchSection.defaultProps = {
  numOfCols: 3,
  btnAlign: "left",
  checkAuth: false,
  buttonAlignIsRight: false,
};

SearchSection.propTypes = {
  children: PropTypes.node,
  searchControls: PropTypes.object,
  numOfCols: PropTypes.number,
  btnSearch: PropTypes.object,
  btnAlign: PropTypes.string,
  additionalBtns: PropTypes.arrayOf(node),
  additionalRightBtns: PropTypes.arrayOf(node),
  checkAuth: PropTypes.bool,
};

export default SearchSection;
